import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=b78dfa3a&scoped=true&"
import script from "./NewUser.vue?vue&type=script&lang=js&"
export * from "./NewUser.vue?vue&type=script&lang=js&"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=b78dfa3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78dfa3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b78dfa3a', component.options)
    } else {
      api.reload('b78dfa3a', component.options)
    }
    module.hot.accept("./NewUser.vue?vue&type=template&id=b78dfa3a&scoped=true&", function () {
      api.rerender('b78dfa3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/SystemManagement/users-management/new-user/NewUser.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/SystemManagement/users-management/new-user/NewUser.vue
// module id = +DNw
// module chunks = 0